export const locale_en = {
    "lang": "en",
    "data": {
        "HELLO-WORLD": {
                NAME: "Hello world"
            },
        },
    
}